import { type ReactNode, createElement } from "react";

import type { AppDispatch } from "app/store";
import type { ConfirmDialogOptions } from "components/confirm-dialog/confirm-dialog.component";
import { setOptions } from "components/confirm-dialog/confirm-dialog.slice";

import { CancellationMessageConfirmContent } from "./cancellation-message-choice.component";

/**
 * Put the "Send cancellation message?" question into a shared confirm dialog the caller is
 * about to open. Dispatches the dialog's options with the action button disabled until
 * staff answer, and returns the content to dispatch and a reader for the answer, to call
 * from the dialog's `onChange`.
 */
export function withCancellationMessageChoice(
  dispatch: AppDispatch,
  {
    body,
    who,
    options
  }: { body?: ReactNode; who?: string; options?: ConfirmDialogOptions }
): { content: ReactNode; answer: () => boolean | undefined } {
  let answer: boolean | undefined;
  dispatch(setOptions({ ...options, actionButtonDisabled: true }));
  const content = createElement(CancellationMessageConfirmContent, {
    body,
    who,
    onPick: (send: boolean) => {
      const first = answer === undefined;
      answer = send;
      if (first)
        dispatch(setOptions({ ...options, actionButtonDisabled: false }));
    }
  });
  return { content, answer: () => answer };
}
